import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from '@angular/material/radio';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ComponentsModule } from '@ridango/components';
import { CoreModule } from '@ridango/core';

import { BackButtonComponent } from './buttons/back-button/back-button.component';
import { SortButtonComponent } from './buttons/sort-button/sort-button.component';
import { RidangoIconsComponent } from './icons/icons.component';
import { AutocompleteInputComponent } from './input-fields/autocomplete-input/autocomplete-input.component';
import { SwappableInputsComponent } from './input-fields/swappable-inputs/swappable-inputs.component';
import { TimeInputComponent } from './input-fields/time-input/time-input.component';
import { BasicLoadingSpinnerComponent } from './loaders/basic-loading-spinner/basic-loading-spinner.component';
import { RotatingLoadingSpinnerComponent } from './loaders/rotating-loading-spinner/rotating-loading-spinner.component';
import { TicketBlockItemComponent } from './ticket/ticket-block-item/ticket-block-item.component';
import { TicketBlockComponent } from './ticket/ticket-block/ticket-block.component';
import { TicketWrapperComponent } from './ticket/ticket-wrapper/ticket-wrapper.component';
import { AlertComponent } from './alert/alert.component';
import { TabButtonComponent } from './buttons/tab-button/tab-button.component';
import { DatetimeSelectComponent } from './input-fields/datetime-select/datetime-select.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatListHintComponent } from './hints/static-list-hint/mat-list-hint.component';
import { RidangoUiSkeletonLoaderComponent } from './loaders/skeleton-loader/skeleton-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
    declarations: [
        AutocompleteInputComponent,
        BackButtonComponent,
        BasicLoadingSpinnerComponent,
        RotatingLoadingSpinnerComponent,
        SortButtonComponent,
        SwappableInputsComponent,
        TimeInputComponent,
        TicketWrapperComponent,
        TicketBlockComponent,
        TicketBlockItemComponent,
        RidangoIconsComponent,
        AlertComponent,
        DatetimeSelectComponent,
        TabButtonComponent,
        MatListHintComponent,
        RidangoUiSkeletonLoaderComponent
    ],
    imports: [
        CoreModule,
        ComponentsModule,
        BrowserModule,
        ReactiveFormsModule,
        MatRadioModule,
        MatFormFieldModule,
        MatIconModule,
        IonicModule,
        FormsModule,
        TranslateModule,
        NgxSkeletonLoaderModule.forRoot({
            animation: 'progress-dark',
            loadingText: 'Loading',
            theme: {
                'background-color': 'var(--ion-color-light)',
                'border-radius': '0.5rem',
                'height': '44px',
                'width': '100%',
                'margin': '0.5rem'
            }
        })
    ],
    exports: [
        AutocompleteInputComponent,
        BackButtonComponent,
        BasicLoadingSpinnerComponent,
        RotatingLoadingSpinnerComponent,
        SortButtonComponent,
        SwappableInputsComponent,
        TimeInputComponent,
        TicketWrapperComponent,
        TicketBlockComponent,
        TicketBlockItemComponent,
        BrowserAnimationsModule,
        MatDividerModule,
        MatFormFieldModule,
        MatRadioModule,
        MatIconModule,
        MatListModule,
        RidangoIconsComponent,
        AlertComponent,
        TabButtonComponent,
        DatetimeSelectComponent,
        MatListHintComponent,
        RidangoUiSkeletonLoaderComponent
    ],
    providers: [
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: { color: 'primary' }
        }
    ]
})
export class UiModule {}
